<template>
  <div>
    <h3>Optional Items</h3>
    <p>
      These items can be further configured in the advanced settings menu.
    </p>
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class OptionalItems extends Vue {}

</script>
